import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import FAQPage from '../../features/faq/indexFAQ';

const Page = () => (
  <MainLayout>
    <FAQPage />
  </MainLayout>
);

export default Page;
